import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommonDefault from '../Common/SelectCommonDefault';

//mock para select //
import { mockCorrespondencia } from '../ObjetoFer';


class CorrespondenciaYcontacto extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            email:""
        };
        this.handleChangeEMail = this.handleChangeEMail.bind(this)
        this.selectDomicilio = this.selectDomicilio.bind(this)
    }

    handleChangeEMail(value) {
            this.setState({ email: value },()=>this.props.onBlurTextBox("email", this.state.email));
    }

    componentWillReceiveProps(){
        if(this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID && this.props.data.comEmail == false && this.props.data.comDomicilioPostal == false){
            
            if(this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID.TipoCorrespondenciaId == 1){
                this.props.correspondenciaModo("domicilioPostal")
            }else{
                this.props.correspondenciaModo("email")
            }
        }
        if(this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID && this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id &&  this.props.tarjetas.esModificacion && !this.props.data.correspondenciaModificacion && !this.props.tarjetas.vuelveDeAdicional){
            //SI SE TRATA DE UNA MODIFICACIÓN CARGO LOS DATOS QUE NO SE CARGAN AUTOMÁTICAMENTE POR SELECTCOMBODEFAULT
             const {datosSolicitud} = this.props.tarjetas;
             let formaComunicacion = datosSolicitud.TipoCorrespondenciaId ?  datosSolicitud.TipoCorrespondenciaId : this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID.TipoCorrespondenciaId;
             let mail = null;
             let flagMail=false;
             let comMail= this.props.data.comEmail;
             

             if(formaComunicacion == 1){
                this.props.correspondenciaModo("domicilioPostal")
             }else if(formaComunicacion == 2){
                this.props.correspondenciaModo("email")
             }
                         
             //SI ENTRE LAS FORMAS DE COMUNICACIÓN REGISTRADAS PARA LA CUENTA GUARDADA ESTÁ EL MAIL LO CARGO
             if(datosSolicitud && Array.isArray(datosSolicitud.Comunicacion)){
                datosSolicitud.Comunicacion.map(formaCom=>{
                    if(formaCom.codigoTipoComunicacion == "EMAIL"){
                        mail=formaCom.Contacto;
                        flagMail=true;
                    } 
                })
             }

             if(mail && !this.props.data.email){
                this.props.onBlurTextBox("email", mail)
             }

            //SI LAS SELECCIONES SE REALIZARON CORRECTAMENTE, O BIEN NO CORRESPONDÍAN POR EL PRODUCTO, SE PASA EL FLAG DE CARGA DE DATOS DE LA MODIFICACIÓN A TRUE
             if((flagMail && this.props.data.email) || !flagMail) this.props.cargarDatosModificacion("correspondenciaModificacion");
        }
    }

    selectDomicilio(action,domicilioId){
        //función que trae los códigos geográficos para llenar el combo según el código postal del domicilio seleccionado
        let domicilio={};

        let domicilios = this.props.data.DOMICILIOS_CLIENTE;

        domicilios.map(dom=>{
            if(dom.Id == domicilioId){
                domicilio = dom
            }
        })
        
        if(!this.props.data.buscandoCodigoGeografico && this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID && this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id && this.props.data.domicilioSeleccionadoId != domicilioId && action == "domicilioSeleccionadoId"){
            
            this.props.selectDomicilioVisa(domicilio,"domicilioSeleccionadoId")
        }else if(!this.props.data.buscandoCodigoGeografico && this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID && this.props.data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id && this.props.data.domicilioSeleccionadoId != domicilioId && action == "comDomicilioSeleccionadoId"){
            
            this.props.selectDomicilioVisa(domicilio,"comDomicilioSeleccionadoId")
        }
    }
    
    render() {
        const { data, correspondenciaModo, tarjetas } = this.props;
        const  selecciones = data;
        let cliente = tarjetas.clienteResultadoBusqueda;

        let valoresDefault;

        if(!tarjetas.esModificacion){
            if(data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO != undefined) valoresDefault = data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO
        }else{
            //SE TOMAN TELÉFONO Y CELULAR DE LA SOLICITUD GUARDADA PARA SELECCIONARLOS COMO VALOR DEFAULT
            let telefonoGuardado="0";
            let celularGuardado="0";
            tarjetas.datosSolicitud.Comunicacion.map(forma=>{
                if(forma.codigoTipoComunicacion == "TELFIJO") telefonoGuardado = forma.Contacto;
                if(forma.codigoTipoComunicacion == "CELULAR") celularGuardado = forma.Contacto;
            })
            valoresDefault = tarjetas.datosSolicitud;
            valoresDefault.telefonoSeleccionado = telefonoGuardado;
            valoresDefault.celularSeleccionado = celularGuardado;
        }
        
        let modoCorrespondencia

      
        if(tarjetas.solicitudCuenta.comEmail) modoCorrespondencia = "email"
        if(tarjetas.solicitudCuenta.comDomicilioPostal) modoCorrespondencia = "domicilioPostal"


            return (
                <div className="row">
                    <div className="correspondencia-contacto-cliente col-md-12">
                        <div className="divisor-section bottom-separator" >
                            <h2>Correspondencia y Contacto con el Cliente </h2>
                        </div>
                        <div className="corespondencia-contacto-body">
                            <div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Domicilio
                                        </label>
                                <SelectCommonDefault  selectCombo={this.selectDomicilio} nombreAction={"domicilioSeleccionadoId"} infoData={data.DOMICILIOS_CLIENTE} valorCombo={valoresDefault["DomicilioSeleccionadoDefaultId"] ? valoresDefault["DomicilioSeleccionadoDefaultId"] : valoresDefault["domicilioSeleccionadoId"]}  selecciones={selecciones} />
                                {!data.ERROR_CUENTA.domicilioSeleccionadoId
                                && <label className="error">{"Debe seleccionar un domicilio."}</label>}
                            </div>
                             <div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Código Geografico
                                </label>
                                <SelectCommonDefault  selectCombo={this.props.selectCombo} nombreAction={"codigoGeograficoId"} infoData={data.ATLAS_CODIGO_GEOGRAFICO} valorCombo={valoresDefault["CodigoGeograficoDefaultId"] ? valoresDefault["CodigoGeograficoDefaultId"] : valoresDefault["codigoGeograficoId"]}  selecciones={selecciones} />
                                {!data.ERROR_CUENTA.codigoGeograficoId
                                && <label className="error">{"Debe seleccionar un código geográfico."}</label>}
                            </div>
                            <div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Teléfono Fijo
                                        </label>
                                <SelectCommonDefault selectCombo={this.props.selectCombo} nombreAction={"telefonoSeleccionado"} infoData={data.TELEFONOS_CLIENTE} valorCombo={valoresDefault["TelefonoSeleccionadoDefaultId"] ? valoresDefault["TelefonoSeleccionadoDefaultId"] : valoresDefault["telefonoSeleccionado"]}  selecciones={selecciones} />
                                {!data.ERROR_CUENTA.telefonoSeleccionado
                                && <label className="error">{"Debe seleccionar un teléfono fijo o celular."}</label>}
                            </div>
                            <div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Celular
                                </label>
                                <SelectCommonDefault selectCombo={this.props.selectCombo} nombreAction={"celularSeleccionado"} infoData={data.CELULARES_CLIENTE} valorCombo={valoresDefault["CelularSeleccionadoDefaultId"] ? valoresDefault["CelularSeleccionadoDefaultId"] : valoresDefault["celularSeleccionado"]}  selecciones={selecciones} />
                                {!data.ERROR_CUENTA.telefonoSeleccionado
                                && <label className="error">{"Debe seleccionar un teléfono fijo o celular."}</label>}
                            </div>
                            <div className="form-group bottom-separator-xs">
                                <div className="col-md-12 no-padding-left">
                                    <label className="label-primary">
                                    Medio para el Envío de Correspondencia
                                   </label>
                                </div>
                                <div>
                                    <div className="row row-radio">
                                        <div className="col-xs-12">
                                            <div className="container-radio radio-margin">
                                                <input id="correspondenciaModo" type="radio" name="group11" checked={this.props.tarjetas.solicitudCuenta.comDomicilioPostal== true} />
                                                <label className="lbl-radio label-secondary check-radio-new" onClick={() => correspondenciaModo("domicilioPostal")} >
                                                    Domicilio Postal
                                                    </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row row-radio">
                                        <div className="col-xs-12">
                                            <div className="container-radio radio-margin">
                                                <input id="correspondenciaModo" type="radio" name="group11" checked={this.props.tarjetas.solicitudCuenta.comEmail == true} />
                                                <label className="lbl-radio label-secondary check-radio-new" onClick={() => correspondenciaModo("email")} >
                                                    Correo Electrónico
                                                    </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    <div className="bottom-separator-xs" />
                                    {!data.ERROR_CUENTA.comTipo
                                && <label className="error">{"Debe seleccionar medio para el envío de correspondencia."}</label>}
                            </div>
                           { <div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Domicilio Correspondencia
                                        </label>
                                <SelectCommonDefault texto={true} selectCombo={this.selectDomicilio} nombreAction={"comDomicilioSeleccionadoId"} infoData={data.DOMICILIOS_CLIENTE} valorCombo={valoresDefault["comDomicilioSeleccionadoDefaultId"] ? valoresDefault["comDomicilioSeleccionadoDefaultId"] : valoresDefault["comDomicilioSeleccionadoId"]}  selecciones={selecciones} />
                                {!data.ERROR_CUENTA.comDomicilioSeleccionadoId
                                && <label className="error">{"Debe seleccionar un domicilio para el envío de correspondencia."}</label>}
                            </div>}
                            {<div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Código Geografico
                                        </label>
                                <SelectCommonDefault texto={true} selectCombo={this.props.selectCombo} nombreAction={"comCodGeogId"} infoData={data.ATLAS_CODIGO_GEOGRAFICO_COMUNICACION} valorCombo={valoresDefault["comCodGeogDefaultId"] ? valoresDefault["comCodGeogDefaultId"] : valoresDefault["comCodGeogId"]}  selecciones={selecciones} />
                                {!data.ERROR_CUENTA.comCodGeogId
                                && <label className="error">{"Debe seleccionar un código geográfico para el envío de correspondencia."}</label>}
                            </div>}
                           { <div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    E-mail
                                        </label>
                                <input className="form-control default-select" type="email" value={tarjetas.solicitudCuenta.email}   placeholder="ingrese mail..." onChange={e=>this.handleChangeEMail(e.target.value)}>
                                </input>
                                {!data.ERROR_CUENTA.email 
                                && <label className="error">{"Debe ingresar un correo electrónico para el envío de correspondencia."}</label>}
                                {!data.ERROR_CUENTA.emailFormato
                                && <label className="error">{"Debe ingresar un correo electrónico válido."}</label>}
                            </div>}
                        </div>
                    </div>
                </div>
            )
    }
}

export default CorrespondenciaYcontacto;